import React from 'react';
import { Link } from 'react-router-dom';
import RubikVisual from './RubikVisual';

const Hero: React.FC = () => {
  return (
    <section className="relative min-h-screen flex items-center pt-32 pb-20 overflow-hidden">
      <div className="container mx-auto px-6 grid lg:grid-cols-2 gap-12 items-center">
        <div className="flex flex-col gap-8">
          <div className="flex items-center gap-4">
            <img
              src="https://lqpglobal.com/logocubo.png"
              alt="LQP Global Logo"
              className="h-14 md:h-20 w-auto object-contain drop-shadow-[0_0_15px_rgba(255,255,255,0.2)]"
            />
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/5 border border-white/10 text-[10px] font-semibold tracking-wider uppercase text-blue-400">
              <span className="relative flex h-2 w-2">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-blue-400 opacity-75"></span>
                <span className="relative inline-flex rounded-full h-2 w-2 bg-blue-500"></span>
              </span>
              Tech Premium 2026
            </div>
          </div>

          <h1 className="text-4xl md:text-6xl font-extrabold leading-[1.1] tracking-tight text-gradient">
            Diseñamos sistemas digitales que <br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-orange-400 via-red-500 to-purple-600">
              ordenan y hacen crecer tu negocio
            </span>
          </h1>

          <p className="text-lg md:text-xl text-gray-400 max-w-xl leading-relaxed">
            Transformamos procesos desordenados en soluciones digitales claras, eficientes y escalables para pymes, comercios y empresas que quieren trabajar mejor y vender más.
          </p>

          <div className="flex flex-col sm:flex-row items-center gap-4">
            <Link
              to="/contacto"
              className="w-full sm:w-auto px-8 py-4 bg-white text-black font-bold rounded-xl hover:bg-gray-100 transition-all transform hover:scale-105 active:scale-95 shadow-xl shadow-white/5"
            >
              Hablemos de tu negocio
            </Link>
            <Link
              to="/soluciones"
              className="w-full sm:w-auto px-8 py-4 glass text-white font-bold rounded-xl hover:bg-white/10 hover:border-white/40 hover:shadow-[0_0_20px_rgba(255,255,255,0.05)] transition-all border border-white/20 active:scale-95"
            >
              Ver cómo podemos ayudarte
            </Link>
          </div>

          <div className="flex items-center gap-6 pt-4">
            <div className="flex -space-x-3">
              {[1, 2, 3, 4].map((i) => (
                <img
                  key={i}
                  src={`https://picsum.photos/seed/${i + 20}/40/40`}
                  className="w-10 h-10 rounded-full border-2 border-[#050505]"
                  alt={`Cliente satisfecho ${i}`}
                  loading="lazy"
                />
              ))}
            </div>
            <div className="text-sm text-gray-500">
              <span className="text-white font-bold">+150</span> empresas ya escalaron con LQP
            </div>
          </div>
        </div>

        <div className="relative flex items-center justify-center">
          <RubikVisual />
          {/* Decorative glows */}
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-blue-500/5 blur-[100px] rounded-full -z-10" />
          <div className="absolute top-1/3 left-1/4 w-[300px] h-[300px] bg-red-500/5 blur-[80px] rounded-full -z-10" />
        </div>
      </div>
    </section>
  );
};

export default Hero;
